import api from './api';
import authHeader from './auth-header';

class SkillsService {
    getTests() {
        return api.get('/skills/tests', { 
            headers: authHeader(),
            params: { _t: Date.now() } // Cache busting
        });
    }

    getTest(testId) {
        return api.get(`/skills/tests/${testId}`, { headers: authHeader() });
    }

    createTest(data) {
        return api.post('/skills/tests', data, { headers: authHeader() });
    }

    updateTest(testId, data) {
        return api.put(`/skills/tests/${testId}`, data, { headers: authHeader() });
    }

    deleteTest(testId) {
        return api.delete(`/skills/tests/${testId}`, { 
            headers: authHeader(),
            params: { _t: Date.now() } // Cache busting
        });
    }

    getTestResults(testId) {
        return api.get(`/skills/tests/${testId}/results`, { headers: authHeader() });
    }
}

const skillsService = new SkillsService();
export default skillsService;




